import { AnyAction } from 'redux';
import { AppContext, AppContextActions, ExternalLinkState } from '../models/app-context-model';

const InitialState: AppContext = {	
	externalLinkState: {
		renderModal: false,
		linkUrl: '',
		linkInnerHtml: '',
	},	
};

export const appContextApiReducer = (state: AppContext = InitialState, action: AnyAction): AppContext => {

	switch (action.type) {		
		case AppContextActions.SET_EXTERNAL_LINK_STATE:
			return {
				...state,
				externalLinkState: action.payload,
			};		
		default: return state;
	}
};

export const setExternalLinkState = (linkState: ExternalLinkState): AnyAction => {
	return {
		type: AppContextActions.SET_EXTERNAL_LINK_STATE,
		payload: linkState,
	};
};